export default __webpack_public_path__ + "static/media/dunaways.0333c05d.jpeg";